import api from '../api/api';

export interface AttendanceRecord {
  id?: number;
  student_id: number;
  name?: string;
  date?: string;
  status: string;
  confidence?: number;
  review_status?: string;
}

export const getStudentAttendance = async (studentId: number, startDate?: string, endDate?: string): Promise<AttendanceRecord[]> => {
  const params: any = { student_id: studentId };
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const response = await api.get('/attendance/report', { params });
  return response.data as AttendanceRecord[];
}; 